exports.list = {
    path: '/laporan_aktivitas_barang',
    name: 'laporan_aktivitas_barang', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/laporan_aktivitas_barang/List.vue"),
  }